export default "__VITE_ASSET__Suz_984w__"